module.exports = __webpack_public_path__ + "static/media/Protein cookies.265fff12.jpg";